import React, {useEffect, useState} from 'react';
import Step1 from "./Step1";
import Step2 from "./Step2";
import axios from 'axios';

function FooterPopup() {

    const [visible, setVisible] = useState(false);
    const [step, setStep] = useState(0);
    const [options, setOptions] = useState({
        ATTENT_TEXT: '',
        ATTENT_TEXT2: '',
        ATTENT_NOT: '',
    });
    const referer = new URLSearchParams(window.location.search).get('referer');
    const maxStep = referer?.includes('opt') ? 1 : 2;
// TODO - перенести все в папку local
    useEffect(() => {
        const ageAccess = sessionStorage.getItem("age_access");
        if (localStorage?.age_access !== '1' || ageAccess !== '1') {
            axios.get('/bitrix/php_interface/enterego_class/Subsidiary/ajax.php'
            ).then(response => {
                setOptions(response.data.options)
                setStep(1)
                setVisible(true)
            })
        } else {
            sessionStorage.setItem("age_access", "1");
            setVisible(false)
        }

    }, []);

    if (!visible || step > maxStep || step===0) {
        return null;
    }
    const renderStep = () => {
        switch (step) {
            case 1:
                return <Step1 key="1" step={step} setStep={setStep} options={options} maxStep={maxStep}/>;
            case 2:
                if (!referer?.includes('opt')) {
                    return <Step2 key="2" step={step} setStep={setStep} maxStep={maxStep} />;
                }
                return null
            default:
                return null;
        }
    };

    return (
        <div className="flex items-center justify-center fixed z-40 h-screen w-screen dark:bg-fancyboxDark top-0 left-0
        bg-fancybox overlay-box">
            <div className="md:rounded-lg rounded-xl dark:bg-darkBox bg-white rounded-0 relative z-50 p-8 m-auto
            md:max-w-lg max-w-md w-screen md:h-auto">
                {renderStep()}
            </div>
        </div>
    );
}

export default FooterPopup;